<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="ASP排产监测"></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
    <div id="center_1" slot="main"/>
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "center_1",
  components: { ChartTitle,DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_1"));
      this.setOptions();
    },
    setOptions() {
      const data = [];
      for (let i = 1; i <= 31; i++) {
        data.push(`${i}日`);
      }
      this.chart.setOption({
        color: ["#009dff", "#22e4ff", "#3bffd0"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          bottom: "2%",
          data: ["未排产", "已排产"],
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        grid: {
          left: "8%",
          right: "9%",
          top: "10%",
          bottom:"17%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          data: data,
        },
        yAxis: {
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
          type: "value",
        },
        series: [
          {
            name: "未排产",
            type: "line",
            smooth: true,
            data: [
              120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90, 230,
              210, 120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90,
              230, 210, 120, 132, 101, 134, 90,
            ],
            color: "#009dff",
          },
          {
            name: "已排产",
            type: "line",
            smooth: true,
            data: [
              220, 182, 191, 234, 290, 330, 310, 220, 182, 191, 234, 290, 330,
              310, 220, 182, 191, 234, 290, 330, 310, 220, 182, 191, 234, 290,
              330, 310, 220, 182, 191, 234,
            ],
            color: "#22e4ff",
          },
          {
            // 设置涟漪特效动画
            type: "effectScatter",
            coordinateSystem: "cartesian2d",
            data: [['13日',330],['20日',230]],
            symbolSize: 9,
            // 何时显示特效:'render'-绘制完成后显示特效 'emphasis'-高亮（hover）的时候显示特效
            showEffectOn: "render",
            // 涟漪特效配置
            rippleEffect: {
              // 波纹的绘制方式,可选'stroke'和'fill'
              brushType: "stroke",
            },
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.9)",
                shadowBlur: 38,
                shadowColor: "rgba(255,255,255,0.9)",
              },
            },
            zlevel: 1,
          },
        ],
      });
    },
     //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 30vh;
  #center_1 {
    height: 100%;
  }
}
</style>
